import Vue from 'vue';
import { formatDate } from '@/utils/utils';

function $dateformat(date, format = 'yyyy-MM-dd hh:mm:ss') {
    return formatDate(date, format);
}

Vue.use({
    install: function (Vue: any) {
        // 1. 添加全局方法或 property
        Vue.$dateformat = $dateformat;

        // 4. 添加实例方法
        Vue.prototype.$dateformat = $dateformat;
    },
});

export { $dateformat };
